import { Box, Icon, Text } from '@rbilabs/universal-components';

export const ButtonText = Text.withConfig({
  color: Styles.color.white,
  textAlign: 'center',
  fontFamily: 'heading',
});

export const SubHeading = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
});

export const Section = Box.withConfig({
  marginY: '$3',
});

export const SectionTitle = Text.withConfig({
  variant: 'headerThree',
  marginBottom: '$4',
  textTransform: 'capitalize',
});

export const IconTitle = Icon.withConfig({
  marginRight: '$2',
  marginBottom: '$4',
  size: {
    base: '$6',
    md: '$8',
  },
});

export const Container = Box.withConfig({
  width: 'full',
});
